'use strict';

const Mn = require('backbone.marionette');
const MemberModel = require('common/domain/entity/member');
const GroupMemberIconView = require('common/ui/view/group/member-icon');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const MemberItemTemplate = require('balus/ui/template/body/group/sidebar/member-item.hbs');

module.exports = Mn.View.extend({
    model: MemberModel,
    tagName: 'li',
    className: 'list-item',
    template: MemberItemTemplate,
    regions: {
        icon: '.list-item-icon',
        title: '.list-item-header-title',
    },
    serializeData: function() {
        const groupRole = this.getOption('groupRoles').get(this.model.getRole());
        return {
            role: groupRole ? groupRole.getName() : ''
        };
    },
    onRender: function() {
        this.showChildView('icon', new GroupMemberIconView({model: this.model}));
        this.showChildView('title', new GroupMemberNameView({model: this.model}));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/sidebar/member-item.js